import { baseApi } from 'core/api';

const state = () => ({
    _autoRecharge: null,
    _hasAutorechargeFailureStatus: false,
    _autorechargeInfo: null,
    _loadingRecharge: false,
});

const getters = {
    autoRecharge: (state) => state._autoRecharge,
    hasAutorechargeFailureStatus: (state) => state._hasAutorechargeFailureStatus,
    autorechargeInfo: (state) => state._autorechargeInfo,
};

const actions = {
    getBillingAutoRecharge() {
        if (this._loadingRecharge) return;
        this._setAutoRechargeLoading(true);

        return baseApi
            .get('core/billing/auto-recharge')
            .then((response) => {
                this._setAutoRechargeLoaded(response.data);
                return response;
            })
            .finally(() => {
                this._setAutoRechargeLoading(false);
            });
    },

    updateBillingAutoRecharge(isActive) {
        let data = {
            is_active: isActive,
        };

        return baseApi.patch('core/billing/auto-recharge', data).then((response) => {
            if (isActive) {
                this._setAutoRechargeEnabled();
            } else {
                this._setAutoRechargeDisabled();
            }

            return response;
        });
    },

    createBillingAutoRecharge(form) {
        return form.post('core/billing/auto-recharge').then((response) => {
            this._setAutoRechargeUpdated(response.data);

            return response;
        });
    },

    clearAutorechargeFailure({ status = true, cookie, data }) {
        if (status) {
            cookie.set('has_autorecharge_failure', status, 1);
            this._setAutoRechargeClear();
        } else {
            this._setAutoRechargeClear();
            cookie.delete('has_autorecharge_failure');
        }

        if (data) {
            this._setAutoRechargeDataUpdate(data);
        }
    },

    setBackupSourceId(sourceId) {
        this._setAutoRechargeBackupSourceSet(sourceId);
    },

    _setSubscription(data) {
        this._autoRecharge = data.auto_recharge || null;
    },

    _setAutoRechargeLoading(status) {
        this._loadingRecharge = status;
    },

    _setAutoRechargeDataUpdate(data) {
        this._autorechargeInfo = data;
    },

    _setAutoRechargeClear() {
        this._hasAutorechargeFailureStatus = !this._hasAutorechargeFailureStatus;
    },

    _setAutoRechargeLoaded(autoRecharge) {
        this._autorechargeInfo = autoRecharge;
        this._autoRecharge = autoRecharge || null;
    },

    _setAutoRechargeEnabled() {
        this._autoRecharge.is_active = true;
    },

    _setAutoRechargeDisabled() {
        this._autoRecharge.is_active = false;
    },

    _setAutoRechargeUpdated(autoRecharge) {
        this._autoRecharge = autoRecharge || null;
    },

    _setAutoRechargeBackupSourceSet(sourceId) {
        this._autoRecharge.backup = sourceId;
    },
};

export default {
    state,
    getters,
    actions,
};
